import react, { useState, useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Button from "./components/Button";
import ButtonList from "./components/ButtonList";
import Checkbox from "./components/Checkbox";
import CheckList from "./components/CheckList";
import Article from "./components/Article";
import SearchIndex from "./SearchIndex";
import LinkedList from "./LinkedList";
import getParam from "./getParam";
import searchArticles from "./searchArticles";
import {
  getCategoryData,
  getCategoryList,
  getArticleData,
  getAsideArticleData,
} from "./CarrierData";

/**
 * 配列を+でつないでstringにする
 * @param {array} arr - 連結したい配列
 * @returns {string} - +で連結された文字列
 */
const joinPlus = (arr) => {
  return arr.join("+");
};

/**
 * 保持しているisActiveすべてを変更する処理
 * @param {object} node - 変更したいisActiveの親node
 * @param {boolean} status - 状態
 * @return {void}
 */
const changeIsActiveOAllChild = (node, status) => {
  if (typeof status != "boolean") return;
  let keys = Object.keys(node);
  keys.map((key) => {
    if (node[key].hasOwnProperty("isActive")) node[key].isActive = status;

    if (node[key].hasOwnProperty("child"))
      changeIsActiveOAllChild(node[key]["child"], status);
  });
};

/**
 * 絞り込みボタン一覧を制作
 */
const ButtonArea = (stateUseData, setUseData, param) => {
  // console.log(`render ButtonArea`);
  const [subCatState, setSubCatState] = useState(false);
  const history = useHistory();

  useEffect(() => {
    // ボタンクリックの履歴の制作とセット
    let job = "";
    let loc = "";
    let oth = "";
    let keys = Object.keys(stateUseData.selectedCategories);
    keys.map((key) => {
      let item = stateUseData.selectedCategories[key];
      if (key == "職種" && Object.keys(item).length != 0) {
        job = joinPlus(Object.keys(item));
      } else if (key == "勤務地" && item != null) {
        loc = joinPlus(Object.keys(item));
      } else if (key == "採用区分" && item != null) {
        oth = joinPlus(Object.keys(item));
      }
    });

    let param = job != "" ? `job=${job}&` : "";
    param += loc != "" ? `loc=${loc}&` : "";
    param += oth != "" ? `oth=${oth}` : "";

//    history.push(`/recruit/entry/index.html?${param}`);
    history.replace(`/recruit/entry/?${param}`);
  }, [stateUseData]);

  /**
   * 絞り込み条件を制作する処理
   * @param {*} val - 条件カテゴリのid
   */
  const SearchInit = (val) => {
    let node = stateUseData.searchIndex.hashMap[val];
    let parent = LinkedList.getLinkedListAncestor(node);

    if (
      stateUseData.selectedCategories[parent.value][node.value] == undefined
    ) {
      stateUseData.selectedCategories[parent.value][node.value] = val;
      node.raw.isActive = true;
    } else {
      delete stateUseData.selectedCategories[parent.value][node.value];
      node.raw.isActive = false;
    }

    if (parent.value == "職種") {
      // 「すべて」のボタンをfalseに
      stateUseData.searchIndex.hashMap["a1000"].raw.isActive = false;
    } else if (parent.value == "勤務地") {
      // 「すべて」のボタンをfalseに
      stateUseData.searchIndex.hashMap["a2000"].raw.isActive = false;
    } else if (parent.value == "採用区分") {
      // 「すべて」のボタンをfalseに
      stateUseData.searchIndex.hashMap["a3000"].raw.isActive = false;
    }

    // 状態の更新
    setUseData({ ...stateUseData });
  };

  /**
   * subカテゴリ用
   */
  const searchInitForSubCat = (val) => {
    let node = stateUseData.searchIndex.hashMap[val];
    let parent = LinkedList.getLinkedListAncestor(node);

    let item = Object.keys(node._prev.raw).filter((key) => key.length >= 5);
    if (
      node._prev.raw[item[0]].hasOwnProperty("isActive") &&
      node._prev.raw[item[0]].isActive
    ) {
      // 選択を全消し
      Object.keys(stateUseData.selectedCategories[parent.value]).map((item) => {
        delete stateUseData.selectedCategories[parent.value][item];
      });

      // 状態の更新
      node.raw.isActive = true;

      //選択肢の更新
      stateUseData.selectedCategories[parent.value][node.value] = node.value;

      // 「すべて」ボタンの状態をfalseに
      node._prev.raw[item[0]].isActive = false;
    } else {
      if (
        stateUseData.selectedCategories[parent.value][node.value] == undefined
      ) {
        stateUseData.selectedCategories[parent.value][node.value] = val;
        node.raw.isActive = true;
      } else {
        delete stateUseData.selectedCategories[parent.value][node.value];
        node.raw.isActive = false;
      }
    }

    // 状態の更新
    setUseData({ ...stateUseData });
  };

  /**
   * すべての検索条件をリセットし、ボタンの状態も更新する
   */
  const SearchAllThat = (val) => {
    let node = stateUseData.searchIndex.hashMap[val];
    let parent = LinkedList.getLinkedListAncestor(node);

    let testKeys = Object.keys(stateUseData.selectedCategories[parent.value]);

    // すべての選択を消す
    testKeys.map((item) => {
      delete stateUseData.selectedCategories[parent.value][item];
    });

    // カテゴリデータのisActiveを全てfalseに
    changeIsActiveOAllChild(stateUseData.categories[parent.value], false);

    // クリックした「すべて」ボタンをtrueに
    if (stateUseData.searchIndex.hashMap.hasOwnProperty(val))
      stateUseData.searchIndex.hashMap[val].raw.isActive = true;

    // もしボタンが「職種」なら選択している職種をリセット
    if (parent.value == "職種") {
      let jobTypeKeys = Object.keys(stateUseData.selectedJobType);
      jobTypeKeys.map((key) => {
        delete stateUseData.selectedJobType[key];
      });
    }

    // 状態の更新
    setUseData({ ...stateUseData });
  };

  /**
   * スイッチングボタン用の選択スタックを制作する処理
   * 子nodeがあればallボタンにチェックをいれ、子nodeを選択アイテムリストに全て追加する。
   */
  const SearchSwitchingButtonChild = (val) => {
    let node = stateUseData.searchIndex.hashMap[val];
    let parent = LinkedList.getLinkedListAncestor(node);

    // 職種のすべてのチェックを外す。
    if (parent.value == "職種") {
      // 「すべて」のボタンをfalseに
      stateUseData.searchIndex.hashMap["a1000"].raw.isActive = false;
    } else if (parent.value == "勤務地") {
      // 「すべて」のボタンをfalseに
      stateUseData.searchIndex.hashMap["a2000"].raw.isActive = false;
    } else if (parent.value == "採用区分") {
      // 「すべて」のボタンをfalseに
      stateUseData.searchIndex.hashMap["a3000"].raw.isActive = false;
    }

    let testKeys = Object.keys(stateUseData.selectedCategories[parent.value]);
    testKeys.map((item) => {
      // 絞り込み条件のすべての選択を消す
      delete stateUseData.selectedCategories[parent.value][item];

      // 絞り込み条件のすべての状態を更新する
      if (
        stateUseData.searchIndex.hashMap[item] != null &&
        stateUseData.searchIndex.hashMap[item].raw !== null
      )
        stateUseData.searchIndex.hashMap[item].raw.isActive = false;
    });

    Object.keys(stateUseData.categories[parent.value]).map((item) => {
      if (stateUseData.categories[parent.value][item].id.length <= 4) {
        Object.keys(stateUseData.categories[parent.value][item].child).map(
          (subItem) => {
            if (
              stateUseData.categories[parent.value][item]["child"][subItem].id
                .length >= 4
            ) {
              stateUseData.categories[parent.value][item]["child"][
                subItem
              ].isActive = false;
            }
          }
        );
      }
    });

    // 職種ボタン（第二階層ボタン）の選択内容を更新
    if (stateUseData.selectedJobType[val] == undefined) {
      let jobTypeKeys = Object.keys(stateUseData.selectedJobType);
      // 第二階層の選択肢を全て消す
      jobTypeKeys.map((key) => {
        delete stateUseData.selectedJobType[key];
        stateUseData.categories[parent.value][key].isActive = false;
      });
      // 選択したカテゴリを追加
      stateUseData.selectedJobType[val] = val;
      stateUseData.categories[parent.value][val].isActive = true;
    } else {
      delete stateUseData.selectedJobType[val];
      stateUseData.categories[parent.value][val].isActive = false;
    }

    // 選択した第二階層のカテゴリに属する子nodeを全て絞り込み条件に追加する
    if (node.raw.child != null) {
      let childItemKeys = Object.keys(node.raw.child);
      childItemKeys.map((key) => {
        if (key.length <= 5) {
          stateUseData.selectedCategories[parent.value][key] = key;
        }

        // 選択したサブカテゴリのallボタンの状態をtrueにする
        if (key.length >= 5) {
          stateUseData.searchIndex.hashMap[key].raw.isActive = true;
        }
      });
    }

    // 状態の更新
    setUseData({ ...stateUseData });
  };

  /**
   * サブカテゴリの「すべて」ボタンの処理
   * 引数からもらったカテゴリを絞り込み条件に追加する
   */
  const addSubCat = (val) => {
    let node = stateUseData.searchIndex.hashMap[val];
    let parent = LinkedList.getLinkedListAncestor(node);
    let testKeys = Object.keys(stateUseData.selectedCategories[parent.value]);
    testKeys.map((item) => {
      // 絞り込み条件のすべての選択を消す
      delete stateUseData.selectedCategories[parent.value][item];

      // 絞り込み条件のすべての状態を更新する
      if (
        stateUseData.searchIndex.hashMap[item] != null &&
        stateUseData.searchIndex.hashMap[item].raw !== null
      )
        stateUseData.searchIndex.hashMap[item].raw.isActive = false;
    });

    // 絞り込み条件に選択している職種のサブカテゴリを全て追加する。
    let jobChildKeys = Object.keys(node._prev.raw);
    jobChildKeys.map((key) => {
      if (key.length <= 4) stateUseData.selectedCategories["職種"][key] = key;
    });

    // サブカテゴリのallボタンの状態の更新
    if (stateUseData.searchIndex.hashMap.hasOwnProperty(val))
      stateUseData.searchIndex.hashMap[val].raw.isActive = true;

    // 状態の更新
    setUseData({ ...stateUseData });
  };

  let typeKeys = Object.keys(stateUseData.categories);
  return (
    <>
      {typeKeys.map((type, index) => {
        let itemKeys = Object.keys(stateUseData.categories[type]);

        let allBottomItem;
        if (type === "職種") {
          allBottomItem = stateUseData.categories[type]["a1000"];
        } else if (type === "勤務地") {
          allBottomItem = stateUseData.categories[type]["a2000"];
        } else if (type === "採用区分") {
          allBottomItem = stateUseData.categories[type]["a3000"];
        }
        let bottomClass =
          "c-tag -outline_blue -size_M -circle p-tag-list__item js-job-type";
        let selectorAllProps = {
          label: allBottomItem.title,
          id: allBottomItem.id,
          isActive: allBottomItem.isActive,
        };

        let selectItemsKeys = Object.keys(
          stateUseData.selectedCategories["職種"]
        );
        let jobTypeKeys = Object.keys(stateUseData.selectedJobType);
        // TODO:別ページへ飛んだ後ハッシュマップへのアクセスが出来なくなる
        let selectJobType =
          jobTypeKeys.length >= 1
            ? Object.keys(
                stateUseData.searchIndex.hashMap[jobTypeKeys[0]].raw.child
              ).length - 1
            : 10000;
        let suCatSelectorAllPropsId = 0;
        // 職種の中で表示しているサブカテゴリ
        let currentCat = [];
        // TODO:別ページへ飛んだ後ハッシュマップへのアクセスが出来なくなる
        if (jobTypeKeys.length >= 1) {
          Object.keys(
            stateUseData.searchIndex.hashMap[jobTypeKeys[0]].raw.child
          ).map((item) => {
            if (item.length <= 5) currentCat.push(item);

            if (item.length >= 5) suCatSelectorAllPropsId = item;
          });
        }

        let suCatSelectorAllProps = {
          label: "すべて",
          id: suCatSelectorAllPropsId,
          isActive: selectJobType === selectItemsKeys.length,
        };

        let checkBoxItemData = {};
        let buttonItemData = {};

        buttonItemData.category = stateUseData.categories[type];
        buttonItemData.list = stateUseData.categoriesList[type]

        if (type === "職種") {
          return (
            <>
              <fieldset className="p-search-box__filter-item p-tag-list">
                <legend className="p-tag-list__label">
                  <p className="c-sentence  -black -size_18_16 -bold">{type}</p>
                </legend>
                <div className="p-tag-list__items">
                  <Button
                    {...selectorAllProps}
                    onClick={SearchAllThat}
                    addClass={bottomClass}
                    ariaPressed="true"
                  />
                  <ButtonList
                    {...buttonItemData}
                    onClick={SearchSwitchingButtonChild}
                    addClass={bottomClass}
                    ariaPressed="false"
                  />
                </div>
              </fieldset>
              {(() => {
                itemKeys.map((jobType, index) => {
                  if (stateUseData.categories[type][jobType].isActive) {
                    if (jobType === "a1000") return;
                    checkBoxItemData.category =
                      stateUseData.categories[type][jobType]["child"];
                    checkBoxItemData.list = stateUseData.categoriesList["jobs_child"][jobType];
                  }
                });

                if (Object.keys(checkBoxItemData).length === 0) return;

                return (
                  <fieldset className="p-search-box__filter-item -check -underline_pc p-check-list">
                    <legend className="p-check-list__label"></legend>
                    <div
                      className={`p-search-box__sub-area ${
                        subCatState ? "-open" : ""
                      }`}
                    >
                      <div
                        className="p-search-box__sub-label"
                        onClick={() => setSubCatState(!subCatState)}
                      >
                        <div className="p-search-box__sub-label-icon"></div>
                        <div className="p-search-box__sub-label-text">
                          <p className="c-sentence  -black -size_18_16 -bold">
                            さらに絞り込む
                          </p>
                        </div>
                      </div>
                      <div
                        className={`p-search-box__sub-items p-check-list__items -sp_row ${
                          subCatState ? "-open" : ""
                        }`}
                      >
                        {Object.keys(checkBoxItemData).length ? (
                          <>
                            <Checkbox
                              {...suCatSelectorAllProps}
                              onClick={(val) => {
                                addSubCat(val);
                              }}
                            />
                            <CheckList
                              {...checkBoxItemData}
                              onClick={searchInitForSubCat}
                            />
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </fieldset>
                );
              })()}
            </>
          );
        } else {
          return (
            <fieldset className="p-search-box__filter-item -check -underline_sp p-check-list">
              <legend className="p-check-list__label">
                <p className="c-sentence -black -size_18_16 -bold">{type}</p>
              </legend>
              <div className="p-check-list__items">
                <Checkbox {...selectorAllProps} onClick={SearchAllThat} />
                <CheckList
                  list={stateUseData.categoriesList[type]}
                  category={stateUseData.categories[type]}
                  onClick={SearchInit}
                />
              </div>
            </fieldset>
          );
        }
      })}
    </>
  );
};

/**
 * 記事一覧を表示する
 */
const ArticleList = (stateUseData) => {
  const selectedCategories = stateUseData.selectedCategories;
  const articleData = stateUseData.articlesData;
  // 絞り込み処理
  let searchRes = searchArticles({ ...selectedCategories }, { ...articleData });
  let searchResKeys = Object.keys(searchRes);

  if (searchResKeys.length == 0) {
    let notFoundMessage = "条件に一致する募集は見つかりませんでした。検索範囲を広げて再検索してください。";

    // 職種のみの条件で募集要項が存在するか検索
    let selectedJobtypes = {
      '職種': selectedCategories['職種'],
      '勤務地': {},
      '採用区分': {}
    };
    const articleJobtypesData = stateUseData.articlesData;
    let searchJobtypesRes = searchArticles({ ...selectedJobtypes }, { ...articleJobtypesData });
    let searchJobtypesResKeys = Object.keys(searchJobtypesRes);
    if (searchJobtypesResKeys.length == 0) {
      notFoundMessage = "選択している職種では、現在募集はありません。";
    }

    return (
      <p class="p-search-box__article-area__message">{notFoundMessage}</p>
    );
  } else {
  return (
    <div className="p-grid-auto-fill  -col_2 -gap30_30">
      {searchResKeys.map((key) => {
        let props = {
          link: searchRes[key].link,
          title: searchRes[key].title,
          categories: searchRes[key].categorys,
          attribute: searchRes[key].attribute,
        };

        return (
          <div className="p-grid-auto-fill__item">
            <Article {...props} />
          </div>
        );
      })}
    </div>
  );
  }
};

/**
 * サポート記事を表示する
 */
const asideArticle = (stateUseData) => {
  const asideArticles = stateUseData.asideArticle;
  let articleKeys = Object.keys(asideArticles);
  return (
    <>
      <div class="p-recruit-links">
        {articleKeys.map((key) => (
          <div class="p-recruit-links__item">
            <a
              key={key}
              class="c-textlink-out-content -size_18_14"
              href={asideArticles[key].link}
            >
              {asideArticles[key].title}
            </a>
          </div>
        ))}
      </div>
    </>
  );
};

/**
 * paramから選択しているカテゴリをtrueにする
 */
const updateCatData = (stateUseData, setUseData, param) => {
  if (stateUseData.searchIndex == null) return null;
  if (param == null) return null;

  let paramKey = Object.keys(param);

  // 「すべて」のボタンの状態をリセット
  stateUseData.searchIndex.hashMap["a1000"].raw.isActive = false;
  stateUseData.searchIndex.hashMap["a2000"].raw.isActive = false;
  stateUseData.searchIndex.hashMap["a3000"].raw.isActive = false;
  if (!param.hasOwnProperty("job"))
    stateUseData.searchIndex.hashMap["a1000"].raw.isActive = true;
  if (!param.hasOwnProperty("loc"))
    stateUseData.searchIndex.hashMap["a2000"].raw.isActive = true;
  if (!param.hasOwnProperty("oth"))
    stateUseData.searchIndex.hashMap["a3000"].raw.isActive = true;

  // 各チェックボックスの状態を更新
  paramKey.map((key) => {
    for (let i = 0; i < param[key].length; i++) {
      let item = param[key][i];
      let node = stateUseData.searchIndex.hashMap[item];
      if (node != undefined && node.raw != null) {
        if (node.raw.isActive != undefined) node.raw.isActive = true;
        changeIsActiveOfAllParent(node, true);

        if (key == "job") {
          stateUseData.selectedCategories["職種"][item] = item;
          stateUseData.selectedJobType[node._prev._prev.value] =
            node._prev._prev.value;
        } else if (key == "loc") {
          stateUseData.selectedCategories["勤務地"][item] = item;
        } else if (key == "oth") {
          stateUseData.selectedCategories["採用区分"][item] = item;
        }
      }
    }
  });

  // 状態を更新
  setUseData({ ...stateUseData });
};

/**
 * 全ての親ノードのisActiveの値を変更する
 */
const changeIsActiveOfAllParent = (node, status) => {
  let iterator = node._prev;
  while (iterator != null) {
    if (
      iterator.hasOwnProperty("raw") &&
      iterator.raw.hasOwnProperty("isActive")
    )
      iterator.raw.isActive = status;

    iterator = iterator._prev;
  }
  return;
};

/**
 * このページで使用するデータ
 * {
 *  categories: カテゴリのrawデータ,
 *  selectedJobType: 職種の中で選択したカテゴリ,
 *  selectedCategories: { 選択したカテゴリデータ
 *    '職種': {},
 *    '勤務地': {},
 *    '採用区分': {}
 *  },
 *  searchIndex :{ 検索用インデックス
 *
 *  },
 *  articlesData: { 記事データ
 *
 *  },
 *  asideArticle: { サブ記事データ
 *
 *  }
 * }
 */
const useData = {
  categories: {},
  selectedJobType: {},
  selectedCategories: {
    職種: {},
    勤務地: {},
    採用区分: {},
  },
  searchIndex: {},
  articlesData: {},
  asideArticle: {},
};

const Carrier = () => {
  const location = useLocation();

  const [stateUseData, setUseData] = useState(useData);

  let param = getParam(location.search);

  /**
   * paramから選択しているカテゴリの内容を更新する処理（ページ遷移時のみ実行）（中の処理は同期しないので処理が終了したらset関数で更新する）
   */
  useEffect(() => {
    Promise.all([getCategoryData(), getCategoryList(), getArticleData(), getAsideArticleData()])
      .then(([cateData, cateList,  articleData, asideArticleData]) => {
        // 検索インデックスを制作
        let searchIndex = new SearchIndex();
        searchIndex.buildPathIndex(cateData.data);

        // 検索インデックスデータをセット
        stateUseData.searchIndex = searchIndex;
        // カテゴリデータをセット
        stateUseData.categories = cateData.data;

        stateUseData.categoriesList = cateList.data;

        // 記事データをセット
        stateUseData.articlesData = articleData.data;

        // サポート記事データをセット
        stateUseData.asideArticle = asideArticleData.data;

        if (param != null) {
          updateCatData(stateUseData, setUseData, param);
        }

        // 状態を更新
        setUseData({ ...stateUseData });
      })
      .catch((error) => {
        {
          // error
          console.log(`json-error:${error}`);
        }
      });
  }, []);

  return (
    <>
      <div className="p-search-box__filter-area">
        {ButtonArea(stateUseData, setUseData, param)}
      </div>
      {asideArticle(stateUseData)}
      <div className="p-search-box__article-area">
        {ArticleList(stateUseData, setUseData)}
      </div>
    </>
  );
};

export default Carrier;
